module.exports = __webpack_public_path__ + "static/media/checkin.b8e40eeb.png";